import Navbar from "./components/navbar";
import Meme from "./components/meme";
function App() {
  return (
    <div>
      <Navbar />
      <Meme />
    </div>
  );
}

export default App;
